import { Stack, StackProps } from "@mui/material";

export const Container = ({ children, ...restProps }: StackProps) => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      maxWidth={576}
      minHeight="100%"
      m="0 auto"
      {...restProps}
    >
      {children}
    </Stack>
  );
};
